
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import { useI18n } from 'vue-i18n'
import { createModel } from '@/utils/component'
import { ResetPasswordModel, UpdatePasswordModel } from '@/model/userModel'
import { size } from 'lodash'
import Container from '@/components/form/container/Container.vue'
import { useStore } from '@/store'
import { updatePassword } from '@/apis/user'
import { ElMessage } from 'element-plus'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  components: { Container, CenterForm },
  setup() {
    const { t } = useI18n()
    const route = useRoute()
    const router = useRouter()
    const struct = [
      {
        prop: 'userAccount',
        label: t('userInfo.userAccount'),
        component: 'el-input',
        type: 'text',
        model: '',
        readonly: true
      },
      {
        prop: 'userPassword',
        label: t('restPassword.originalPassword'),
        component: 'el-input',
        type: 'password',
        model: '',
        showPassword: true
      },
      {
        prop: 'newUserPassword',
        label: t('restPassword.newPassword'),
        component: 'el-input',
        type: 'password',
        model: '',
        showPassword: true
      },
      {
        prop: 'confirmPassword',
        label: t('restPassword.confirmPassword'),
        component: 'el-input',
        type: 'password',
        model: '',
        showPassword: true
      }
    ]
    const dataMap = reactive({
      restPwFormStruct: struct,
      restPwFormModel: createModel(struct) as ResetPasswordModel,
      async toSubmit() {
        const params: UpdatePasswordModel = {
          userPassword: dataMap.restPwFormModel.userPassword,
          newUserPassword: dataMap.restPwFormModel.newUserPassword
        }
        const data = await updatePassword(params)
        if (data && data.code === 200 && data.data === 1) {
          ElMessage({
            message: t('user.editSuccessMessage'),
            type: 'success',
            duration: 2000
          })
          useStore().dispatch(UserActionTypes.ACTION_LOGIN_OUT, undefined)
          router.push(`/login?redirect=${route.fullPath}`).catch(err => {
            console.warn(err)
          })
        } else {
          const error = data?.msg ? data.msg : '密码验证失败'
          ElMessage({
            message: error,
            type: 'error',
            duration: 2000
          })
        }
      },
      reset() {
        dataMap.restPwFormModel.userAccount = useStore().state.user.info?.userAccount ?? ''
      }
    })
    const reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/
    const newPasswordVerify = (rule: any, value: any, callback: any) => {
      if (size(value) < 10) {
        callback(new Error(t('restPassword.lengthP')))
      } else if (!reg.test(value)) {
        callback(new Error(t('restPassword.ruleP')))
      } else if (value === dataMap.restPwFormModel.userAccount) {
        callback(new Error(t('restPassword.repeatAccountP')))
      } else {
        callback()
      }
    }
    const confirmPasswordVerify = (rule: any, value: any, callback: any) => {
      if (size(value) < 10) {
        callback(new Error(t('restPassword.lengthP')))
      } else if (!reg.test(value)) {
        callback(new Error(t('restPassword.ruleP')))
      } else if (String(value) === dataMap.restPwFormModel.userAccount) {
        callback(new Error(t('restPassword.repeatAccountP')))
      } else if (String(value) !== dataMap.restPwFormModel.newUserPassword) {
        callback(new Error(t('restPassword.differentP')))
      } else {
        callback()
      }
    }
    const restPwFormRules = {
      userPassword: [{ required: true, message: t('restPassword.oriPasswordP'), trigger: 'blur' }],
      newUserPassword: [{ required: true, validator: newPasswordVerify, trigger: 'blur' }],
      confirmPassword: [{ required: true, validator: confirmPasswordVerify, trigger: 'blur' }]
    }
    onMounted(() => {
      dataMap.restPwFormModel.userAccount = useStore().state.user.info?.userAccount ?? ''
    })
    return {
      t,
      restPwFormRules,
      ...toRefs(dataMap)
    }
  }
})
